module.exports = __webpack_public_path__ + "img/partner.fa1887ec.jpg";